module.exports = __webpack_public_path__ + "img/featureCosme.003.d1a33f53.jpeg";